import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import Button from "@/components/atoms/Button";

type TruncatedTextProps = {
  text?: string;
};

const TruncatedText = ({ text }: TruncatedTextProps) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (textRef.current) {
      const checkTruncation = () => {
        setIsTruncated(textRef.current!.scrollHeight > textRef.current!.clientHeight);
      };

      checkTruncation();

      window.addEventListener("resize", checkTruncation);
      return () => window.removeEventListener("resize", checkTruncation);
    }
  }, [text]);

  return (
    <div>
      <div ref={textRef} className={`text-sm text-tertiary ${!expanded ? "line-clamp-3" : ""}`}>
        {text || t("company.detail.nothingFound")}
      </div>
      {isTruncated && (
        <Button
          onClick={() => setExpanded((prev) => !prev)}
          variants={"textLight"}
          color={"natural"}
          size={"2xs"}
          className={"!px-0.5"}
          label={expanded ? t("showLess") : t("showMore")}
        />
      )}
    </div>
  );
};

export default TruncatedText;
